import type { Parseable } from "./parseable"
import { PhoneNumber } from "./phoneNumber"
import { ValidationError } from "./validation"

export const DUTCH_NUMBER_PREFIX = "+31"

/**
 *  Specifically Dutch phone numbers are important in our software.
 *  We have a separate class for them to easily ensure that a number
 *  is dutch.
 */
export class DutchPhoneNumber extends PhoneNumber {
  constructor(input: string, strict?: boolean)
  constructor(phoneNumber: PhoneNumber, strict?: boolean)
  constructor(input: string | PhoneNumber, strict?: boolean) {
    super(String(input), "NL", strict)

    if (this.prefix !== DUTCH_NUMBER_PREFIX) {
      throw new ValidationError([
        { code: "invalidRegion", message: "error.phoneNumber.invalidRegion", data: { region: "NL" } },
      ])
    }
  }

  /**
   *  Parse a string or undefined into a DutchPhoneNumber.
   *  This method normalizes the phone number format before parsing
   *  using the parent class normalization logic.
   */
  static parse(input: DutchPhoneNumber | string | undefined): DutchPhoneNumber | undefined {
    if (input instanceof DutchPhoneNumber) {
      return input
    }

    if (!input) {
      return undefined
    }

    try {
      return new DutchPhoneNumber(input)
    } catch {
      return undefined
    }
  }
}

const _parseable: Parseable<DutchPhoneNumber> = DutchPhoneNumber
void _parseable
